<main class="container legal-policy-page cookie-policy-page">
  <div class="row mx-2">
    <div class="col-12">
      <h1 class="legal-policy-page__title">Cookie Policy</h1>
      <p class="legal-policy-page__meta">
        CitizeX uses essential browser storage to operate securely. Optional
        analytics and marketing services run only when you enable them.
      </p>
    </div>
  </div>

  <hr />

  <section class="row mx-2 cookie-policy-section">
    <div class="col-12">
      <h2 class="legal-policy-page__section-title">
        Services and browser storage
      </h2>
      <p>
        This table identifies who provides each service and when it can run.
        Third-party storage names and durations can change when providers update
        their services.
      </p>

      <div class="cookie-policy-table-wrap">
        <table class="cookie-policy-table">
          <thead>
            <tr>
              <th scope="col">Service</th>
              <th scope="col">Provider</th>
              <th scope="col">Storage and duration</th>
              <th scope="col">Purpose</th>
              <th scope="col">When it is used</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">CitizeX session</th>
              <td>CitizeX (first party)</td>
              <td>
                Cookie: <code>citizex_session_restore</code>. A browser session
                or up to 7 days when “Remember me” is selected.
              </td>
              <td>
                Supports secure sign-in, session management, fraud prevention,
                and authenticated routes.
              </td>
              <td>
                After successful sign-in; always enabled for core service.
              </td>
            </tr>
            <tr>
              <th scope="row">Cookie preferences</th>
              <td>CitizeX (first party)</td>
              <td>
                LocalStorage: <code>citizex.cookie-preferences</code>. It
                persists until browser storage is cleared.
              </td>
              <td>Remembers your optional-service choices in this browser.</td>
              <td>After you save a choice.</td>
            </tr>
            <tr *ngFor="let service of optionalServices">
              <th scope="row">{{ service.name }}</th>
              <td>{{ service.party }}</td>
              <td>{{ service.storage }}</td>
              <td>{{ service.purpose }}</td>
              <td>{{ service.activation }}</td>
            </tr>
            <tr>
              <th scope="row">Google Maps and Places</th>
              <td>Google</td>
              <td>
                Google may use its own browser storage when location search or
                representative matching is used.
              </td>
              <td>Supports address search and representative matching.</td>
              <td>Only when you use a search or address flow that needs it.</td>
            </tr>
            <tr>
              <th scope="row">Google reCAPTCHA</th>
              <td>Google</td>
              <td>
                Google may use its own browser storage while abuse protection is
                running.
              </td>
              <td>Helps prevent automated abuse.</td>
              <td>
                Only when you start a protected signup or verification flow.
              </td>
            </tr>
            <tr>
              <th scope="row">Didit</th>
              <td>Didit</td>
              <td>
                Didit may use its own browser storage during identity
                verification.
              </td>
              <td>Provides identity verification requested by the user.</td>
              <td>Only when you start identity verification.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="cookie-policy-note">
        CitizeX saves these preferences in localStorage, not a browser cookie.
        Changing a preference cannot remove storage already written on a third
        party’s domain, so the page reloads after an existing choice changes to
        stop previously active services.
      </p>
    </div>
  </section>

  <hr />

  <section class="row mx-2 cookie-policy-section cookie-policy-manage">
    <div class="col-12">
      <h2 class="legal-policy-page__section-title">
        Manage cookie preferences
      </h2>
      <p>
        You can change your optional-service choices at any time. Your choice is
        saved only in the current browser.
      </p>
      <button
        type="button"
        class="cookie-policy-action"
        (click)="openCookiePreferences($event)"
      >
        Manage cookie preferences
      </button>
    </div>
  </section>
</main>
